<template>
    <nav aria-label="Breadcrumb" class="breadcrumb">
      <ol
        class="breadcrumb__list"
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
      >
        <li
          v-for="(crumb, idx) in normalized"
          :key="idx"
          class="breadcrumb__item"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <!-- Link all but the last crumb (or if it has no URL) -->
          <template v-if="crumb.url && !isLast(idx)">
            <!-- Use router-link for internal paths if enabled -->
            <router-link
              v-if="useRouterLinks && isInternal(crumb.url)"
              class="breadcrumb__link"
              :to="crumb.url"
              itemprop="item"
            >
              <span itemprop="name">{{ crumb.name }}</span>
            </router-link>
  
            <a
              v-else
              class="breadcrumb__link"
              :href="crumb.url"
              itemprop="item"
            >
              <span itemprop="name">{{ crumb.name }}</span>
            </a>
          </template>
  
          <!-- Current / last crumb or crumbs without URL -->
          <template v-else>
            <template v-if="isCarousel">
                <router-link
                v-if="useRouterLinks && isInternal(crumb.url)"
                class="breadcrumb__link"
                :to="crumb.url"
                itemprop="item"
              >
                <span itemprop="name">{{ crumb.name }}</span>
              </router-link>
    
              <a
                v-else
                class="breadcrumb__link"
                :href="crumb.url"
                itemprop="item"
              >
                <span itemprop="name">{{ crumb.name }}</span>
              </a>
            </template>
            <template v-else>
              <span
                class="breadcrumb__current"
                :aria-current="isLast(idx) ? 'page' : null"
                itemprop="item"
              >
                <span itemprop="name">{{ crumb.name }}</span>
              </span>
            </template>
          </template>
  
          <!-- Schema.org position -->
          <meta :content="String(crumb.position != null ? crumb.position : (idx + 1))" itemprop="position" />
  
          <!-- Separator (hidden after the last item) -->
          <span v-if="!isLast(idx)" class="breadcrumb__sep" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="#212121" stroke-dasharray="12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12l-7 -7M16 12l-7 7"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.4s" values="12;0"/></path></svg>
          </span>
        </li>
      </ol>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'Breadcrumb',
    props: {
      /** Array like your itemListElement */
      items: {
        type: Array,
        default: () => [],
      },
      /** Turn on to render <router-link> for internal paths (requires vue-router) */
      useRouterLinks: {
        type: Boolean,
        default: true,
      },
      isCarousel:{
        type: Boolean,
        default: false,
      },
    },
    computed: {
      normalized () {
        return (this.items || [])
          .filter(c => c && typeof c.name === 'string' && c.name.trim().length)
          .map(c => ({
            name: String(c.name),
            // prefer .url, fall back to .item
            url: typeof c.url === 'string'
              ? c.url
              : (typeof c.item === 'string' ? c.item : undefined),
            position: typeof c.position === 'number' ? c.position : undefined,
          }));
      },
    },
    methods: {
      isLast (idx) {
        return idx === this.normalized.length - 1;
      },
      isInternal (url) {
        // treat leading "/" (but not "//") as internal
        return /^\/(?!\/)/.test(url);
      },
    },
  };
  </script>
  
  <style scoped>
  .breadcrumb {
    padding: 0rem;
    display: block;
    max-width: 100%;
    background-color: #fff;
    margin-bottom: 0rem;

    @media (max-width: 450px) {
      margin-bottom: 0rem;
    }
  }
  .breadcrumb__list {
    
    list-style: none;
    margin: 0;
    padding: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 2px;
    font-size: 1em;
    font-weight: 900;
    color: var(--ink);
    line-height: 1.2;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 1em;
       @media (max-width: 992px) {
        font-size: 0.9em;
      }
  }
  .carousel-item   .breadcrumb__list {
    margin-bottom: 0;
  }
  .carousel-item a.breadcrumb__link span{
    color:rgb(117, 117, 117);
  }
  .breadcrumb__item {
    display: inline-flex;
    align-items: center;
   
    
  }
  a.breadcrumb__link span {
     color: #212121;
      text-overflow:ellipsis;
        display: block;
    overflow: hidden;
    white-space:nowrap;
    max-width: 300px;
  }

  a.breadcrumb__link span:hover  {
    
    text-decoration: underline;

  }

  .breadcrumb__current {
    font-weight: 600;
  }
  .breadcrumb__sep {
    margin: 0 .25rem;
    display: flex;
    padding-top:2px;
   
  }
  .breadcrumb__current span,.breadcrumb__sep span{
    color: rgb(117, 117, 117)!important;
    text-overflow:ellipsis;
        display: block;
    overflow: hidden;
    white-space:nowrap;
    max-width: 300px;
  }


   
  </style>
  